import { render, staticRenderFns } from "./SwitchBox.vue?vue&type=template&id=4478f408&scoped=true&"
import script from "./SwitchBox.vue?vue&type=script&lang=ts&"
export * from "./SwitchBox.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchBox.vue?vue&type=style&index=0&id=4478f408&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4478f408",
  null
  
)

export default component.exports